"use client";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ClipboardCheck, Users, Film, TrendingUp } from "lucide-react";
export default function ServiceListings() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const services = [{
    id: 1,
    icon: ClipboardCheck,
    title: "Project Management",
    description: "Hands-on project management tailored to your needs, removing daily operational stress so you can focus on execution."
  }, {
    id: 2,
    icon: Users,
    title: "Administrative Assistance",
    description: "Professional support that keeps your business organized and running efficiently with expert administrative services."
  }, {
    id: 3,
    icon: Film,
    title: "Film Project Development & Packaging",
    description: "Specialized services structuring film projects to attract funding and connect with essential industry relationships."
  }, {
    id: 4,
    icon: TrendingUp,
    title: "Strategic Guidance",
    description: "Expert strategic direction that drives clarity, credibility, and forward momentum for your business or creative venture."
  }];
  return <section ref={sectionRef} className="bg-background py-16 sm:py-20 lg:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {Array.isArray(services) && services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={service.id} data-index={i} className={`group flex h-full flex-col border border-border bg-background shadow-soft transition-all duration-[150ms] ease-[cubic-bezier(0.4,0,0.2,1)] hover:-translate-y-1 hover:shadow-medium ${isVisible ? "animate-fade-in-up" : "opacity-0"}`} style={{
            animationDelay: isVisible ? `${i * 50}ms` : "0ms"
          }}>
                <CardHeader>
                  <div className="mb-4 transition-transform duration-[150ms] ease-[cubic-bezier(0.4,0,0.2,1)] group-hover:scale-[1.03]">
                    <Icon className="size-12 text-primary" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-lg font-semibold text-foreground">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex flex-1 flex-col justify-between">
                  <p className="mb-6 text-sm leading-relaxed text-muted-foreground">
                    {service.description}
                  </p>
                  <Link to="/ServicesPage" className="inline-flex">
                    <Button variant="outline" size="sm" className="w-full transition-all duration-[150ms] ease-[cubic-bezier(0.4,0,0.2,1)] hover:scale-[1.02] hover:bg-primary/5">
                      Learn More
                    </Button>
                  </Link>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}